import React from "react";
import { sortStatusMessageLines } from "tap/utils/sortStatusMessageLines.js";
import { scalarizeJobTaskFieldValue } from "tap/utils/normalizeLicensingJobViewTask.js";

/**
 * Renders status messages with newline characters displayed as line breaks.
 * Multi-line "Processing N of M ..." progress lines are sorted by N.
 * @param {Object} props
 * @param {string} props.value - Status message from the grid row
 */
export function StatusMessageCellRenderer({ value }) {
  if (value == null || value === "") {
    return null;
  }

  const message = String(scalarizeJobTaskFieldValue(value)).replace(
    /\\n/g,
    "\n",
  );
  const lines = sortStatusMessageLines(message.split("\n"));

  return (
    <span>
      {lines.map((line, index) => (
        <React.Fragment key={index}>
          {index > 0 && <br />}
          {String(line)}
        </React.Fragment>
      ))}
    </span>
  );
}
